const RESERVED_KEYS = ['global', 'environment', 'installation'];

const useMemoryKeyInputValidation = ({ key, scope = 'workflow' }) => {
  const memoryKey = key || '';
  const invalidKey = RESERVED_KEYS.includes(memoryKey) && scope === 'workflow';
  const memoryKeyDescription = invalidKey ? 'Reserved keyword, cannot be used with workflow scope' : '';

  return { memoryKey, memoryKeyDescription, invalidKey };
};

export default useMemoryKeyInputValidation;
